// PopupBudgetPurchaseorder component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Input from '../../../common/form/input/input.jsx'
import Button from '../../../common/common/button/button.jsx'
import Popover from '../../../common/common/popover/popover.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'

class PopupBudgetPurchaseorder extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }

    this.data = {
      keyword: '',
      options: [],
      purchaseOrders: [],
      items: [],
      activity: null,
      contactName: '',
      bHideAdd: false
    }
  }

  static get propTypes () {
    return {
      container: PropTypes.any,
      onSearchSupplier: PropTypes.func,
      onCreateItemSupplier: PropTypes.func,
      onDeleteItemSupplier: PropTypes.func,
      target: PropTypes.object,
      onClickAdd: PropTypes.func,
      onViewPurchaseOrder: PropTypes.func,
      onContactAdd: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      container: null,
      onSearchSupplier: null,
      onCreateItemSupplier: null,
      onDeleteItemSupplier: null,
      target: null,
      onClickAdd: null,
      onViewPurchaseOrder: null,
      onContactAdd: null
    }
  }

  show (activity, purchaseOrders) {
    this.data.activity = activity
    this.data.purchaseOrders = purchaseOrders || []

    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    const _className = `popup-budgetpurchaseorder popup-form ${
      this.state.active ? 'active' : ''
    }`

    return (
      <Popover
        placement='bottom'
        container={this.props.container || this}
        target={this.props.target}
        show={this.state.active}
        onHide={this.hide.bind(this)}
      >
        <div className={_className} onClick={this._onClickPopover.bind(this)}>
          <div className='popupheader'>
            <h3 className='title'>
              <IntlMessage ident='project.form.titlePurchaseOrderPopup' />
            </h3>
            <span className='action' onClick={this._onClickClose.bind(this)}>
              <i className='icon icon-popup-budgetclose' />
            </span>
          </div>

          {this._renderContent()}
        </div>
      </Popover>
    )
  }

  /* Event handlers */
  _onShowPopup (_ev) {
    this.show()
  }

  _onClickClose () {
    this.hide()
  }

  _onSearchSupplier (keyword) {
    this.data.keyword = keyword

    const excludeIds = this.data.purchaseOrders.map(
      (obj, _idx) => obj.contactId
    )

    if (this.props.onSearchSupplier) {
      if (this._searchTimeClient) window.clearTimeout(this._searchTimeClient)

      this._searchTimeClient = window.setTimeout(() => {
        this.props.onSearchSupplier(keyword, excludeIds, (options) => {
          this.data.options = options
          this.forceUpdate()
        })
      }, 1000)
    }

    if (this.data.options.length === 0) {
      this.setState({ contactName: this.data.keyword, bHideAdd: false })
    }
  }

  _onSelectSupplier (supplierObj) {
    const itemSupplier = _.cloneDeep(supplierObj)

    this.data.purchaseOrders.push(itemSupplier)
    this.data.options = []
    this.data.keyword = ''
    this.data.activity.purchaseOrders = this.data.purchaseOrders

    if (this.props.onCreateItemSupplier) {
      this.props.onCreateItemSupplier(
        {
          contactId: itemSupplier.contactId,
          budgetItemId: this.data.activity.id,
          purchaseOrderId: itemSupplier.purchaseOrderId
        },
        (createRes) => {
          itemSupplier.id = createRes.id
        }
      )
    }

    this.forceUpdate()
  }

  _onClickAdd (orderObj) {
    if (this.props.onClickAdd) {
      this.props.onClickAdd(orderObj)
    }
  }

  _onClickPopover (ev) {
    ev.preventDefault()
    ev.stopPropagation()
  }

  _onClickDelete (contactId) {
    const suppliers = _.remove(
      this.data.purchaseOrders,
      (orderObj) => orderObj.contactId === contactId
    )
    this.data.activity.purchaseOrders = this.data.purchaseOrders

    if (suppliers.length > 0 && this.props.onDeleteItemSupplier) {
      this.props.onDeleteItemSupplier(suppliers[0].id)
    }

    this.forceUpdate()
  }

  _onClickButton (orderObj) {
    if (this.props.onViewPurchaseOrder) {
      this.props.onViewPurchaseOrder(orderObj.purchaseOrderId)
    }
  }

  /* Private functions */
  _renderContent () {
    let info = ''
    if (this.data.purchaseOrders.length === 0) {
      info = (
        <p className='info'>
          <IntlMessage ident='project.form.popupPurchaseInfo' />
        </p>
      )
    }

    return (
      <div className='popupcont'>
        {info}

        <div className='content'>
          {this._renderPurchaseOrders()}

          <div className='contheader'>
            <Input
              name='keyword'
              type='text'
              prefixIcon='popup-search'
              maxLength={128}
              label='project.viewBudget.addSupplier'
              className='popupinput'
              value={this.data.keyword}
              autoFocus
              onChange={this._onSearchSupplier.bind(this)}
            />
          </div>

          {this._renderSearchOptions(this.data.options)}
        </div>
      </div>
    )
  }

  _renderPurchaseOrders () {
    if (this.data.purchaseOrders.length === 0) {
      return ''
    }

    return (
      <div className='selectedlist'>
        {this.data.purchaseOrders.map((orderObj, idx) => (
          <div className='selecteditem' key={idx}>
            <h2 className='itemtitle'>{orderObj.contact.title}</h2>
            {orderObj.purchaseOrder && orderObj.purchaseOrder.invoiceNo ? (
              <Button
                className='button_phase'
                title={orderObj.purchaseOrder.invoiceNo}
                onClick={this._onClickButton.bind(this, orderObj)}
              />
            ) : (
              <div
                className='contaction'
                onClick={this._onClickAdd.bind(this, orderObj)}
              >
                <span className='acticon'>
                  <i className='icon icon-popup-add' />
                </span>
                <span className='acttitle'>
                  <IntlMessage ident='project.form.addPo' />
                </span>
              </div>
            )}
            {!orderObj.purchaseOrderId && !orderObj.bHasExpense && (
              <span
                className='itemicon action'
                onClick={this._onClickDelete.bind(this, orderObj.contactId)}
              >
                <i className='icon icon-form-delete' />
              </span>
            )}
          </div>
        ))}
      </div>
    )
  }

  _renderSearchOptions (_searchOptions) {
    const msgText = (
      <p>
        <IntlMessage ident='common.list.autoCompleteContactInfo' />
        <IntlMessage ident='common.list.autoCompleteClick' />
        <i className='icon icon-autocomplete-plus' />
        <IntlMessage ident='common.list.autoCompleteButton' />
      </p>
    )

    if (this.data.options && this.data.options.length > 0) {
      return (
        <div className='searchlist'>
          {this.data.options.map((supplierObj, idx) => (
            <div
              className='popupsearchlistitem'
              key={idx}
              onClick={this._onSelectSupplier.bind(this, supplierObj)}
            >
              {supplierObj.contact.title}
            </div>
          ))}
        </div>
      )
    } else if (
      !this.state.bHideAdd &&
      this.data.keyword &&
      this.data.options.length === 0
    ) {
      return (
        <div className='autocomplete-message'>
          <IconButton
            type='primary'
            size='big'
            icon='autocomplete-add'
            title='common.list.titleAdd'
            canHover={false}
            className='wizard-client-add'
            onClick={this._handleAddClick.bind(this)}
          />
          <h2>
            <IntlMessage ident='common.list.autoCompleteContactTitle' />
          </h2>
          {msgText}
        </div>
      )
    }

    return ''
  }

  _handleAddClick (e) {
    e.preventDefault()
    this.setState({ bHideAdd: true })

    if (this.props.onContactAdd) {
      this.props.onContactAdd(this.state.contactName, () => {
        this._onSearchSupplier(this.state.contactName)
      })
    }
  }
}

export default PopupBudgetPurchaseorder
